const architects = [
  {
    id: 'A1',
    url: 'zaborsky',
    name: 'Заборскі Георгій Уладзіміравіч',
    bornDate: '11/11/1909',
    born: '11 лістапада 1909',
    deceased: '27 красавіка 1999',
    description: 'Народны архітэктар СССР (1981), заслужаны будаўнік Беларусі, акадэмік Расійскай акадэміі архітэктуры і будаўнічых навук, акадэмік Беларускай акадэміі архітэктуры, лаўрэат Дзяржаўнай прэміі СССР (1971).',
    image: 'http://bsa.by/ckfinder/userfiles/images/4(2).jpg',
    placeOfResidence: 'Мінск',
    placeOfBirth: 'Мінск',
    bio: [
      {date: '1909', text: 'Георгій Заборскі нарадзіўся ў Мінску ў сям\'і Уладзіміра Георгіевіча Заборскага, бухгалтара Маскоўска-Брэсцкай чыгункі, і Алены Іванаўны Заборскі (Зеглинг).'},
      {date: '1930', text: 'Паступіў у Мінскую профтехшколу сялянскага вогнетрывалай будаўніцтва. Першую практыку Г. Заборскі праходзіў на будаўнічай пляцоўцы будынка Дома ўрада. Тут жа адбылося яго знаёмства з архітэктарам І. Лангбардам.'},
      {date: '1939', text: 'Скончыў Акадэмію мастацтваў. Па конкурсе трапіў у Маскву, але працаваў там нядоўга і хутка атрымаў накіраванне ў Мінск. Тут ён быў прызначаны кіраўніком навуковай экспедыцыі па вывучэнні помнікаў архітэктуры і мастацтва Гомельскай і Палескай абласцей.'},
      {date: '1941-1945', text: 'Пайшоў на фронт добраахвотнікам, але ў баях пад Смаленскам быў цяжка паранены і апынуўся ў шпіталі уральскага гарадка Траецкае, дзе выканаў шэраг праектаў-эскізаў помнікаў, прысвечаных гераічнай перамогі савецкага народа ў Вялікай Айчыннай вайне.'},
      {date: '1945-1964', text: 'Георгій Заборскі кіруе архітэктурна-канструктарскімі майстэрнямі праектных інстытутаў Белдзяржпраект і Мінскпраект і адначасова выкладае на архітэктурным аддзяленні Беларускага політэхнічнага інстытута (цяпер УА «Беларускі нацыянальны тэхнічны ўніверсітэт»).'},
      {date: '1993', text: 'Скончыў творчую дзейнасць. Адной з апошніх яго прац стаў праект помніка ахвярам масавых рэпрэсій у Курапатах пад Менскам.'},
    ],
    project: [
      {date: '1952', text: 'Спраектаваў дом для сям\'і Я. Коласа.'},
      {date: '1954', text: 'Помнік-манумент на пл. Перамогі.'},
      {date: '1962', text: 'Па праектах архітэктара пабудаваныя кінатэатр «Піянер» і музей Вялікай Айчыннай вайны.'},
      {date: '1969', text: 'Адкрыццё мемарыяльнага комплексу «Зiслаў».'},
    ],
    video: {
      id: 'lxMfVdAml1A'
    },
    mapData: {
      center: [53.906840, 27.571457],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://naviny.by/media/2015.09_w1/yacub.jpg',
        width: 4,
        height: 3,
        title: 'Помнік Я.Коласа',
        text: 'Помнік Я.Коласа.'
      },
      {
        num: 2,
        src: 'https://minsknews.by/wp-content/uploads/2018/05/APD_8846-1.jpg',
        width: 2,
        height: 2,
        title: 'Манумент на пл. Перамогі',
        text: 'Манумент на пл. Перамогі.'
      },
      {
        num: 3,
        src: 'https://minsk-old-new.com/assets/images/Image/streets/krasnoarmeyskaya/krasnoarmeyskaya-024.jpg',
        width: 2,
        height: 2,
        title: 'Будынак ЦК ЛКСМБ',
        text: 'Будынак ЦК ЛКСМБ.'
      },
      {
        num: 4,
        src: 'https://planetabelarus.by/upload/resize_cache/iblock/901/1330_887_18e21fe612b4afb807a26ecc22279a1d9/901c0376763ffee6a3fb245ea62fba25.jpg',
        width: 4,
        height: 3,
        title: 'Мінскае Сувораўскае ваеннае вучылішча',
        text: 'Мінскае Сувораўскае ваеннае вучылішча.'
      },
    ],
  },

  {
    id: 'A2',
    url: 'usova',
    name: 'Усава Любоў Дзмітрыеўна',
    bornDate: '9/6/1921',
    born: '6 верасня 1921',
    deceased: 'цяперашні час',
    description: ' Любоў Дзмітрыеўна - асоба ў архітэктурных колах вядомая. Перш за ўсё яна ўвайшла ў будаўнічую летапіс Беларусі як адзін з распрацоўшчыкаў новага пасляваеннага генплана горада Мінска. Пры яе непасрэдным удзеле ў сталіцы збудаваны шматлікія знакавыя аб\'екты. За сваю творчую дзейнасць неаднаразова ўзнагароджвалася граматамі Вярхоўнага Савета БССР, ганаровымі граматамі і граматамі інстытута \'Мінскпраект\', а таксама Саюзаў архітэктараў СССР і БССР. Занесена ў кнігу гонару інстытута \'Мінскпраект\'.',
    image: 'https://minsknews.by/wp-content/uploads/2014/10/Arhitektor-Usova-3.jpg',
    placeOfResidence: 'Мінск',
    placeOfBirth: 'Іркуцк',
    bio: [
      {date: '1921', text: 'Нарадзілася ў Іркуцку 6 верасня 1921 года ў сям’і служачых.'},
      {date: '1930', text: 'Сям’я пераехала ў Маскву, дзе Любоў пасля заканчэння школы паступіла ў Маскоўскі архітэктурны інстытут.'},
      {date: '1941-1945', text: 'У час Вялікай Айчыннай вайны знаходзілася ў эвакуацыі ў Ташкенце.'},
      {date: '1947', text: 'Абараніла ў 1947 з адрозненнем дыпломны праект, пасля чаго была размеркавана на працу ў Мінск ў архітэктурна-планіровачную майстэрню пры Мінгарвыканкаме, дзе таксама працаваў яе муж Васіль Іосіфавіч Герашчанка.'},
      {date: '1989', text: 'Занесена ў кнігу пашаны інстытута «Мінскпраект»'},
    ],
    project: [
      {date: '1950', text: 'Праектавала і аднаўляла галоўны корпус БПІ (БНТУ).'},
      {date: '1952', text: 'Спраектавала Палац піянераў і школьнікаў.'},
      {date: '1954', text: 'Спраектавала будынак абкама КПБ.'},
      {date: '1956', text: 'Спраектавала Беларускі рэспубліканскі тэатр юнага гледача.'},
      {date: '1960-1970', text: 'Выканала шэраг работ па прывязцы і рэканструкцыі школ, дзіцячых садкоў, праектавала жылыя дамы сумесна з мужам у раёне Прывакзальнай плошчы, для рабочых мотавелазаводзе, жылыя кварталы заводаў. Прымала ўдзел у стварэнні сквера каля тэатра оперы і балета парку Перамогі, займалася рэканструкцыяй дзіцячага парку імя М. Горкага.'},
      {date: '1968', text: 'Спраектавала рэспубліканскі дом юнага тэхніка.'},
      {date: '1970-1980', text: 'Выконвала архітэктурна-планіровачную частку Мінскага воднага каскада - вадасховішчаў Дразды і Крыніца.'},
    ],
    video: {
      id: 'FCQd9J67N0o'
    },
    mapData: {
      center: [53.906840, 27.571457],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'http://arcp.by/sites/arcp.by/files/styles/660/public/articlefoto/rsg-13-2014_final_stranica_5_izobrazhenie_0002.jpg',
        width: 4,
        height: 3,
        title: 'Любоў Усава з калегамі',
        text: 'Любоў Усава з калегамі за працай над праектам кінатэатра \'Зорка\'.'
      },
      {
        num: 2,
        src: 'http://arcp.by/sites/arcp.by/files/styles/660/public/articlefoto/rsg-13-2014_final_stranica_5_izobrazhenie_0004.jpg',
        width: 2,
        height: 2 ,
        title: 'Разам з мужам',
        text: 'Любоў Усава разам з мужам Васілём Герашчанка.'
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Minsk_CIS_executive_committee.JPG/800px-Minsk_CIS_executive_committee.JPG',
        width: 2,
        height: 2,
        title: 'Гаркам КПБ',
        text: 'Будынак гаркама КПБ.'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Belarus-Minsk-Railway_Station_Square-4.jpg/800px-Belarus-Minsk-Railway_Station_Square-4.jpg',
        width: 2,
        height: 2,
        title: 'Прывакзальная плошча г.Мiнска',
        text: 'Вароты Мінска на Прывакзальнай плошчы '
      },
      {
        num: 5,
        src: 'https://farm4.static.flickr.com/3286/2958042964_43082c0ef6_o.jpg',
        width: 4,
        height: 3,
        title: 'Рэспубліканскі Палац піянераў і школьнікаў',
        text: 'Рэспубліканскі Палац піянераў і школьнікаў.'
      },
      {
        num: 6,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Enhie%C4%BAsa_Street_26.jpg/1024px-Enhie%C4%BAsa_Street_26.jpg',
        width: 2,
        height: 2,
        title: 'Тэатр юнага гледача',
        text: 'Беларускі рэспубліканскі тэатр юнага гледача.'
      },
      {
        num: 7,
        src: 'https://upload.wikimedia.org/wikipedia/commons/9/9d/BNTU.JPG',
        width: 4,
        height: 3,
        title: 'Галоўны корпус БНПУ ',
        text: 'Галоўны корпус Беларускага нацыянальнага тэхнічнага універсітэта.'
      },
      {
        num: 8,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Alleya_of_Opera_and_Ballet_Theatre%2C_Minsk.JPG/1024px-Alleya_of_Opera_and_Ballet_Theatre%2C_Minsk.JPG',
        width: 2,
        height: 2,
        title: 'Траецкая гара',
        text: ' Сквер вакол Нацыянальнага акадэмічнага Вялікага тэатра оперы і балета Рэспублікі Беларусь.'
      },
      {
        num: 9,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/%D0%9F%D0%B0%D0%BC%D1%8F%D1%82%D0%BD%D0%B8%D0%BA_%D0%97%D0%B0%D1%85%D0%B0%D1%80%D0%B8%D1%8E_%D0%9A%D0%BE%D1%80%D0%BD%D0%B5%D0%B5%D0%B2%D1%83%2C_Minsk%2C_Belarus_-_panoramio_%281%29.jpg/1280px-%D0%9F%D0%B0%D0%BC%D1%8F%D1%82%D0%BD%D0%B8%D0%BA_%D0%97%D0%B0%D1%85%D0%B0%D1%80%D0%B8%D1%8E_%D0%9A%D0%BE%D1%80%D0%BD%D0%B5%D0%B5%D0%B2%D1%83%2C_Minsk%2C_Belarus_-_panoramio_%281%29.jpg',
        width: 2,
        height: 2,
        title: 'Дзіцячы парк імя М. Горкага',
        text: ' Пешаходны мост цераз набярэжную р. Свіслач'
      },
    ],
  },

  {
    id: 'A3',
    url: 'parusnikov',
    name: 'Паруснікаў Міхаіл Паўлавіч',
    bornDate: '11/12/1893',
    born: '12 лістапада 1893',
    deceased: '2 лютага 1968',
    description: 'Савецкі архітэктар, правадзейны член Акадэміі Архітэктуры СССР (1950), акадэмік АН БССР (1950 г.; член-карэспандэнт з 1947). Педагог, прафесар (з 1948). Лаўрэат Дзяржаўнай прэміі Беларускай ССР (1968)',
    image: 'http://cn.flibusta.site/i/89/452389/img_84.jpg',
    placeOfResidence: 'Масква',
    placeOfBirth: 'Масква',
    bio: [
      {
        date: '1913 - 1918',
        text: 'Навучаўся ў МУЖВЗ (яго бацька быў настаяцелем суседняга храма), затым да 1924 года ва ВХУТЕМАСе'
      },
      {
        date: '1924',
        text: 'Працаваў у архітэктурна-праектных арганізацыях Масквы і адначасова выкладаў (1934-1941 гадах, з 1948 года-прафесар) У МАРХІ .'
      },
      {date: '1941 - 1944', text: 'Старшы навуковы супрацоўнік Акадэміі архітэктуры СССР'},
      {date: '1944 - 1948', text: 'Кіраўнік архітэктурна-праектных майстэрняў Камітэта па справах архітэктуры СССР.'},
    ],
    project: [
      {date: '1930', text: 'Аўтар праекта планіроўкі і забудовы Астрахані '},
      {
        date: '1923',
        text: 'Павільён машынабудавання і аўдыторыя на Усерасійскай сельскагаспадарчай і саматужна-прамысловай выставе ў Маскве'
      },
      {
        date: '1936',
        text: 'Шэраг жылых дамоў на праспекце Міру ў Маскве «Дома з аркай» ў Яраслаўлі, у тым ліку дом на Чырвонай плошчы'
      },
      {date: '1950', text: 'Дзяржбанк СССР'},
      {date: '1946—1954', text: 'Жылыя дамы і мост праз р. Свіслач, Спартыўны комплекс «Дынама»'},
    ],
    video: {
      id: 'mrfadR51D0I'
    },
    mapData: {
      center: [53.898869, 27.554819],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://upload.wikimedia.org/wikipedia/commons/7/71/Minsk_skaryny_ave_02.jpg',
        width: 4,
        height: 3,
        title: 'Будынак КДБ у Менску',
        text: 'Будынак КДБ у Менску'
      },
      {
        num: 2,
        src: 'https://upload.wikimedia.org/wikipedia/commons/3/32/NBRB.JPG',
        width: 2,
        height: 2,
        title: 'Будынак Нацбанка РБ',
        text: 'Будынак Нацбанка РБ'
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/commons/c/c5/Захар%27еўскі_мост.jpg',
        width: 2,
        height: 2,
        title: 'Мост праз Свіслач',
        text: 'Мост праз Свіслач'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/d/d0/Buildings_in_Yaroslavl_009.jpg',
        width: 4,
        height: 3,
        title: 'Дом з аркай на Чырвонай плошчы',
        text: 'Дом з аркай на Чырвонай плошчы'
      },
    ],
  },

  {
    id: 'A4',
    url: 'leonid-mendelevich',
    name: 'Леанід Мендэлевіч Левін',
    bornDate: '7/25/1936',
    born: '25 ліпеня 1936',
    deceased: '1 сакавіка 2014',
    description: 'Заслужаны архітэктар Рэспублікі Беларусь, лаўрэат Ленінскай прэміі і прэміі Ленінскага Камсамола, лаўрэат прэміі Валгаградскага Камсамола, лаўрэат Дзяржаўнай прэміі Рэспублікі Беларусь, лаўрэат шматлікіх прэстыжных конкурсаў і аглядаў архітэктурных работ, акадэмік Міжнароднай і Беларускай акадэміі архітэктуры, старшыня Саюза Беларускіх яўрэйскіх грамадскіх аб’яднанняў і абшчын з 1991 па 2014 год. Адзін з аўтараў мемарыяльнага комплексу «Хатынь», за які (у складзе аўтарскага калектыву) быў удастоены Ленінскай прэміі.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Levin_Leonid_Mendele.jpg/800px-Levin_Leonid_Mendele.jpg',
    placeOfResidence: 'Минск',
    placeOfBirth: 'Минск',
    bio: [
      {date: '1954—1960', text: 'Вучоба ў Беларускім політэхнічным інстытуце.'},
      {date: '1960', text: 'Праца ў Інстытуце «Мінскпраект» (ад архітэктара да кіраўніка Майстэрні па забудове цэнтра Мінска).'},
      {date: '1960—1967', text: 'Удзел у стварэнні парку імя 50-годдзя Савецкай улады.'},
      {date: '1968', text: 'Удзел у стварэнні выставачнага павільёна ВДНГ БССР у Мінску.'},
      {date: '1970', text: 'У складзе аўтарскага калектыву быў уганараваны Ленінскай прэміяй за мемарыяльны комплекс 1968—1969 гг. «Хатынь».'},
      {date: '1997', text: 'Дырэктар уласнай творчай майстэрні УП «Творчая майстэрня архітэктара Л. Левіна».'},
      {date: '4 сакавіка 2014', text: 'Пахаваны на Цэнтральнай алеі Усходніх могілак у Мінску.'},
    ],
    project: [
      {date: '1969', text: 'Мемарыяльны комплекс «Хатынь»'},
      {date: '1972', text: 'Помнік Янку Купалу'},
      {date: '1972', text: 'Помнік Якубу Коласу'},
      {date: '1979', text: 'Мемарыяльны комплекс «Праклён фашызму» на месцы спаленай вёскі Шунёўка'},
      {date: '1980 - 1986', text: 'Рэканструкцыя гістарычнай часткі Мінска - «Траецкае прадмесце»'},
      {date: '1984', text: 'Аўтарства станцыі Мінскага метрапалітэна «Плошча Леніна»'},
      {date: '1990', text: 'Аўтарства станцыі Мінскага метрапалітэна «Няміга»'},
      {date: '2004', text: 'Мемарыяльны комплекс загінуўшым яўрэям у г.п. Гарадзея'},
    ],
    video: {
      id: 'P2-yBJvcJUo'
    },
    mapData: {
      center: [53.906840, 27.571457],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://upload.wikimedia.org/wikipedia/commons/0/01/Khatyn_Memorial%2C_Belarus.jpg',
        width: 4,
        height: 3,
        title: 'Мемарыяльны комплекс Хатынь',
        text: 'Мемарыяльны комплекс Хатынь'
      },
      {
        num: 2,
        src: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Belarus-Minsk-Memorial_Pit-2.jpg',
        width: 2,
        height: 2,
        title: 'Мемарыял ахвярам гітлераўскага генацыду «Яма»',
        text: 'Мемарыял ахвярам гітлераўскага генацыду «Яма»'
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/ru/f/ff/Yanka-kupala-minsk.jpg',
        width: 2,
        height: 2,
        title: 'Помнік Янку Купалу',
        text: 'Помнік Янку Купалу'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/9/97/The_Minsk_Thinker_-_panoramio.jpg',
        width: 4,
        height: 3,
        title: 'Помнік Якубу Коласу',
        text: 'Помнік Якубу Коласу'
      },
    ],
  },

  {
    id: 'A5',
    url: 'yesman',
    name: 'Есьман Iгар Iванавiч',
    bornDate: '01/05/1932',
    born: '1 мая 1932',
    deceased: 'цяперашні час',
    description: 'Архітэктар, дызайнер і вынаходнік Ігар Іванавіч Есьман марыў пабудаваць на ўездзе ў Мінск грандыёзны навукова-вучэбны цэнтр: Мінскі архітэктурна-будаўнічы інстытут (МАБI) і звышсучасны Белдзяржуніверсітэт.',
    image: 'https://s16.stc.all.kpcdn.net/share/i/12/2109386/inx960x640.jpg',
    placeOfResidence: 'Мiнск',
    placeOfBirth: 'Мiнск',
    bio: [
      {date: '1948', text: 'Ігар Есьман абраў прафесію архітэктара і стаў студэнтам Мінскага архітэктурна-будаўнічага тэхнікума.'},
      {date: '1959', text: 'Скончыў архітэктурны факультэт Беларускага політэхнічнага інстытута (цяпер БНТУ).'},
      {date: '1960 - 1995', text: 'Працуе ў інстытуце \'Мінскпраект\', прайшоўшы шлях ад простага архітэктара да старэйшага, а затым галоўнага архітэктара праектаў і кіраўніка майстэрні.'},
      {date: '1995 - н.в.', text: 'Ігар Іванавіч знаходзіцца ў вольным творчым палёце думкі, працягваючы здзіўляць і радаваць навакольных. Робіць дэкарацыю-трансформер для спектакля \'Анёл над дахам\'. Захапляецца мастацкай разьбой па каменю, костцы, распрацоўвае дызайн марак, выпускае мініяцюрныя кнігі, вывучае і вырабляе прадметы даўніны ў мініяцюрным варыянце.'},
    ],
    project: [
      {date: '1958', text: 'Уваход-тамбур ў хлебны магазін па вуліцы Раманаўская Слабада.'},
      {date: '1961 - 1963', text: 'Мінскі інстытут замежных моў (цяпер МДЛУ) па вул. Захарава.'},
      {date: '1964', text: 'Інстытут тэхнічнай эстэтыкі па вул. Жылуновіча, вытворчы корпус, выставачная зала.'},
      {date: '1965', text: 'Эксперыментальны дзіцячы сад-яслі на 320 месцаў у мікрараёне «Серабранка-6» і паўторна прымяняюцца дзіцячыя дашкольныя ўстановы.'},
      {date: '1966', text: 'Індывідуальныя жылыя дамы па Партызанскім пр. i Раманаўскай Слабадзе. Інстытут народнай гаспадаркі, актавая і спартыўная залы.'},
      {date: '1967', text: 'Першае месца ў адкрытым конкурсе на распрацоўку эмблемы свята, памятнай медалі і серыі значкоў да 900-годдзя горада Мінска.'},
      {date: '1968', text: 'Комплекс адміністрацыйных будынкаў з залай пасяджэнняў па вул. Някрасава.'},
      {date: '1972', text: 'Комплекс інтэрнатаў з блокамі абслугоўвання Інстытута народнай гаспадаркі па Веласіпедным завулку.'},
      {date: '1970 - 1983', text: 'Архітэктурна-будаўнічы факультэт БНТУ, праспект Незалежнасці 150, г.Мінск.'},
      {date: '1980', text: 'Комплекс будынкаў гасцініцы «Арбіта» па праспекце Пушкіна.'},
      {date: '1990', text: 'Станцыя метро \'Пушкінская\'.'},
    ],
    video: {
      id: 'jL_MPmr0U-U'
    },
    mapData: {
      center: [53.937772, 27.669495],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'http://www.minsk.nemiga.info/silicon-valley/bntu-8.jpg',
        width: 4,
        height: 3,
        title: 'Архітэктурна-будаўнічы факультэт БНТУ',
        text: 'Архітэктурна-будаўнічы факультэт БНТУ'
      },
      {
        num: 2,
        src: 'https://www.belarusinfo.by/ru/images/stories/photo_gallery/20k/15655/%D0%9C%D0%93%D0%9B%D0%A3.jpg',
        width: 4,
        height: 2,
        title: 'Мінскі дзяржаўны лінгвістычны універсітэт',
        text: 'Мінскі дзяржаўны лінгвістычны універсітэт'
      },
      {
        num: 3,
        src: 'http://bseu.by/images/hostels/5.jpg',
        width: 2,
        height: 2,
        title: 'Інтэрнаты Беларускага дзяржаўнага эканамічнага універсітэта',
        text: 'Інтэрнаты Беларускага дзяржаўнага эканамічнага універсітэта'
      },
      {
        num: 4,
        src: 'https://t-ec.bstatic.com/images/hotel/max1024x768/321/32147559.jpg',
        width: 4,
        height: 3,
        title: 'Гасцініца Арбіта, Мінск',
        text: 'Гасцініца Арбіта, Мінск'
      },
    ],
  },

  {
    id: 'A6',
    url: 'sacco',
    name: 'Джузэпэ дэ Сака',
    bornDate: '12/11/1735',
    born: '1735',
    deceased: '1798',
    description: 'Адзін з найбуйнейшых архітэктараў развітога барока і класіцызму, якія працавалі на тэрыторыі сучаснай Беларусі, у XVIII стагоддзі. Прыдворны архітэктар караля Станіслава Аўгуста Панятоўскага. Таксама працаваў у іншых рэгіёнах Рэчы Паспалітай. У творчасці вылучаюцца ансамблі палацава-паркавых рэзідэнцый.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/%D0%9F%D0%BE%D0%BC%D0%BD%D1%96%D0%BA_%D0%A1%D0%B0%D0%BA%D0%B0.JPG/375px-%D0%9F%D0%BE%D0%BC%D0%BD%D1%96%D0%BA_%D0%A1%D0%B0%D0%BA%D0%B0.JPG',
    placeOfResidence: 'Гродна',
    placeOfBirth: 'Верона',
    bio: [
      {date: '1768', text: 'Быў запрошаны ў Варшаву, дзе займаўся мастацкім катафалкам (сastrum doloris) каралевы Марыі Ляшчынскай і праектам перабудовы касцёла святога Яна.'},
      {date: '1771', text: 'Стаў архітэктарам Скарбовай камісіі ВКЛ. Быў рэкамендаваны гродзенскаму старасце Антонію Тызенгаўзу і прыняты на службу, у якасці каралеўскага архітэктара, з усталяваным акладам у 600 злотых. У Рэчы Паспалітай дэ Сака атрымлівае шэраг вайсковых званьняў ВКЛ.'},
      {date: '1771 - 1780', text: 'Выканаў шэраг заказаў мясцовых магнатаў, спраектаваўшы некалькі вядомых палацава-паркавых ансамбляў і гарадскіх рэзідэнцый, у прыватнасці: Свяцкі палац магнатаў Валовічаў, Шчорсаўскі палац Храптовічаў, палацы Тызенгаўза ў Паставах і Вільні (меркавана).'}
    ],

    project: [
      {date: 'XVIII век', text: 'Палац у Цёнжени'},
      {date: 'XVIII век', text: 'Палац Храптовічаў у Шчорсах'},
      {date: 'XVIII век', text: 'Тэатр Тызенгаўза'},
      {date: 'XVIII век', text: 'Свяцкі палац'},
      {date: 'XVIII век', text: 'Палац Тызенгаўза'},
      {date: 'XVIII век', text: 'Мосарскі палац'},
    ],
    video: {
      id: 'TkaLjjNj8Ls'
    },
    mapData: {
      center: [53.684727, 23.834317],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://upload.wikimedia.org/wikipedia/commons/6/6c/Ci%C4%85%C5%BCe%C5%84_-_pa%C5%82ac_biskup%C3%B3w_pozna%C5%84skich_03.jpg',
        width: 4,
        height: 3,
        title: 'Палац у Цёнжени',
        text: 'Палац у Цёнжени'
      },
      {
        num: 2,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/%D0%A1%D1%82%D0%B0%D0%BD%D0%B8%D1%81%D0%BB%D0%B0%D0%B2%D0%BE%D0%B2%D0%BE.JPG/1920px-%D0%A1%D1%82%D0%B0%D0%BD%D0%B8%D1%81%D0%BB%D0%B0%D0%B2%D0%BE%D0%B2%D0%BE.JPG',
        width: 2,
        height: 2,
        title: 'Станіславова (сядзіба)',
        text: 'Станіславова (сядзіба)'
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/%D0%90%D0%BD%D1%81%D0%B0%D0%BC%D0%B1%D0%BB%D1%8C_%D0%BF%D0%BB%D0%BE%D1%89%D0%B0%D0%B4%D0%B8_%D0%A2%D0%B8%D0%B7%D0%B5%D0%BD%D0%B3%D0%B0%D1%83%D0%B7%D0%B0.JPG/1280px-%D0%90%D0%BD%D1%81%D0%B0%D0%BC%D0%B1%D0%BB%D1%8C_%D0%BF%D0%BB%D0%BE%D1%89%D0%B0%D0%B4%D0%B8_%D0%A2%D0%B8%D0%B7%D0%B5%D0%BD%D0%B3%D0%B0%D1%83%D0%B7%D0%B0.JPG',
        width: 2,
        height: 2,
        title: 'Ансамбль плошчы Тызенгаўза',
        text: 'Ансамбль плошчы Тызенгаўза'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/9/97/%C5%9Aviacak._%D0%A1%D1%8C%D0%B2%D1%8F%D1%86%D0%B0%D0%BA_%282006%29.jpg',
        width: 4,
        height: 3,
        title: 'Свяцкі палац',
        text: 'Свяцкі палац'
      },
      {
        num: 5,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/%D0%A2%D0%B5%D0%B0%D1%82%D1%80_%D0%BA%D1%83%D0%BA%D0%BE%D0%BB_%D0%B2_%D0%93%D1%80%D0%BE%D0%B4%D0%BD%D0%BE.JPG/1280px-%D0%A2%D0%B5%D0%B0%D1%82%D1%80_%D0%BA%D1%83%D0%BA%D0%BE%D0%BB_%D0%B2_%D0%93%D1%80%D0%BE%D0%B4%D0%BD%D0%BE.JPG',
        width: 4,
        height: 3,
        title: 'Тэатр Тызенгаўза',
        text: 'Тэатр Тызенгаўза'
      },
    ],
  },
];

const developers = [
  {
    id: 'D1',
    name: 'Іван Канановіч',
    github: 'https://github.com/ivankononovich',
    image: 'https://avatars0.githubusercontent.com/u/41195901?s=400&v=4',
    contribution: '➤Стварыў базавую структуру праекта.\n ➤Рэалізаваў пераход паміж старонкамі з дапамогай react router.\n ➤Рэалізаваў пераклад сайта на тры мовы (тэкст пісала ўся каманда).',
  },
  {
    id: 'D2',
    name: 'Яўген Матвеёнак',
    github: 'https://github.com/ins21',
    image: 'https://ins21.github.io/rsschool-2019Q1-cv/assets/images/1.png',
    contribution: '➤Стварыў кампанент са старонкай архітэктара, выкарыстоўваючы Material UI.\n ➤Дадаў кампанент TimeLine і кампанент Map.\n ➤Пераклаў старонкі двух архітэктараў на беларускую і ангельскую мову.',
  },
  {
    id: 'D3',
    name: 'Кацярына Жадзько',
    github: 'https://github.com/cathzetjo',
    image: 'https://avatars3.githubusercontent.com/u/44948376?s=460&v=4',
    contribution: ' ➤Кампанент старонкі распрацоўшчыкаў. Структураванне і стылізацыя старонкі з выкарыстаннем Material UI.\n' +
      ' ➤Кампанент галерэі з фотаздымкамі на старонках архітэктараў.\n' +
      ' ➤Кантэнт на старонцы архітэктара Усавай Л.Д. з перакладам.\n' +
      ' ➤Кантэнт і малюнак на галоўнай старонцы.',
  },
  {
    id: 'D4',
    name: 'Артур Рубчанка',
    github: 'https://github.com/Arthur199212',
    image: 'https://avatars0.githubusercontent.com/u/46008463?s=460&v=4',
    contribution: '➤Стварыў два кампаненты: меню сайта і архітэктар дня.\n ➤Архітэктар дня выбiраецца па даце нараджэння.\n ➤Меню зроблена адаптыўным і пры дапамозе Material-UI.',
  },
  {
    id: 'D5',
    name: 'Дзмітрый Пархоменка',
    github: 'https://github.com/DmitriyParhomenko',
    image: 'https://avatars0.githubusercontent.com/u/37816988?s=460&v=4',
    contribution: '➤Стварыў два кампаненты у якіх выкарыстоўваецца Material UI: табліца праектаў на старонцы архітэктара і мадальнай акно паказу Відэа з YouTube.\n ➤Абодва кампанента адаптыўныя. Для табліцы ў адаптиве з`яўляецца гарызантальны скролл.\n ➤Правёў працу па стылістыкі ўсяго сайта.',
  },
  {
    id: 'D6',
    name: 'Павел Хоміч',
    github: 'https://github.com/pashax0',
    image: 'https://avatars3.githubusercontent.com/u/17899361?s=460&v=4',
    contribution: '➤Стварыў кампанент футэр сайта з паказам інфармацыі аб распрацоўніках.\n ➤Рэалізацыя кампанента пошуку на станіцы архитэктараў з выдачай вынікаў.\n ➤Кампаненты выкананы з выкарыстаннем Material UI. Базавая SEO аптымізацыя.',
  }
];

const portalDescription = {
  title: 'Архітэктары Беларусі',
  description: '<p>Архітэктура краіны - гэта свайго роду імідж дзяржавы, яна можа раскрываць гістарычную спадчыну, казаць аб перавагах і ўзроўні жыцця дзяржавы.</p>' +
    '<p>Архітэктура Беларусі з\'яўляецца сапраўдным сведчаннем яе багатай гісторыі. Помнікі гісторыі, архітэктурныя збудаванні звязаныя з сярэднявечным, ўсходне-еўрапейскіх і рускім мастацтвам. Яны ўвабралі ў сябе нацыянальныя і еўрапейскія тэндэнцыі развіцця архітэктуры. Замкі Беларусі - гэта унікальныя шэдэўры.</p>' +
    '<p>Шматлікія пабудовы на тэрыторыі краіны выкананы ў візантыйска-балканскім стылі, што робіць іх больш выяўленымі на фоне сучасных збудаванняў. Манументальныя помнікі ў стылі барока, палацы ў Гродне, Магілёве адрозніваюцца вытанчанасцю і вытанчанасцю. Палацавыя ансамблі ў Гомелі ставяцца да помнікаў класіцызму.</p>' +
    '<p>Архітэктура Беларусі звязана з яе гістарычнымі падзеямі, перапляценнем мастацкіх стыляў. Разнастайнасць стыляў робіць краіну яшчэ больш яркай і маляўнічай.</p>' +
    '<p>Беларусь мае вялікую гістарычную спадчыну. І сёння ствараюцца новыя і рэстаўруюцца старадаўнія шэдэўры архітэктуры.</p>' +
    '<p>Гэты партал пра людзей, якія стварылі гістрыю беларускай архітэктуры сваімі рукамі.</p>',
  architectOfTheDay: 'Архітэктар дня',
  img: 'https://i.ibb.co/Brsc9Sw/main-Picture.png',
};

const architectPageLanguage = {
  years: 'Гады жыцця',
  bio: 'Біяграфія',
  projects: 'Праекты',
  projectHeader: {
    columnOne: 'Праекты',
    columnTwo: 'Дата стварэння'
  },
  video: 'Відэа',
  videoButton: 'Прагляд',
  map: 'Месца асноўнай дзейнасці',
  gallery: 'Фотагалерэя',
};

export default {
  SEO: {
    lang: 'by',
    title: 'Архiтэктары Беларусi',
    description: 'Архітэктары Беларусі: біяграфія і іх працы. Хто пабудаваў будынак, у якім годзе, чый праект'
  },
  architects,
  developers,
  portalDescription,
  architectPageLanguage,
  architectsNav: 'Архітэктары',
  developersList: 'Распрацоўнікi',
  homePageLink: 'Галоўная',
  searchLabel: 'Iмя цi месца народжання',
  architectOfTheDayButton: 'Падрабязна',
}
